module.exports = __webpack_public_path__ + "static/media/icon-upload.36e7d27f.svg";